import { Tab as MUITab, TabProps as MUITabProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useScrollableView } from '../Layout';

const useStyles = makeStyles<TabProps>({ name: 'UpliftTab' })(theme => ({
  root: {
    borderBottom: '1px solid #e0e0e0',
    fontWeight: 'bold',
  },
  selected: {
    borderBottom: '2px solid transparent',
    color: theme.palette.primary.main
  },
  textColorPrimary: {
    '&$selected': {
      borderBottomColor: theme.palette.primary.main,
    },
  },
  textColorSecondary: {
    '&$selected': {
      borderBottomColor: theme.palette.secondary.main,
    }
  },
}));

export type TabProps = MUITabProps & {
  jump?: boolean;
  headerOffset?: number;
};

export const Tab: React.VFC<TabProps> = ({ headerOffset = 0, classes: overrideClasses, jump, ...props }) => {
  const scrollableView = useScrollableView();
  const { classes } = useStyles({ classes: overrideClasses }, { props: { classes: overrideClasses } });

  const handleClick = React.useCallback((e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.preventDefault();

    const element = document.getElementById(props.value);

    if (element) {
      scrollableView?.scrollTo({
        top: element.offsetTop - headerOffset,
        behavior: 'smooth',
      });
    }
  }, [ headerOffset, props.value, scrollableView ]);

  if (jump && props.value) {
    return (
      <MUITab
        onClick={handleClick}
        classes={classes}
        {...props}
      />
    );
  }

  return (
    <MUITab classes={classes} {...props} />
  );
};
